import { CSSProperties } from "react";
import styled from "styled-components";

export const FlexDiv = styled.div<{
  $flexDirection?: CSSProperties["flexDirection"];
  $justifyContent?: CSSProperties["justifyContent"];
  $width?: string;
  $height?: string;
  $alignItems?: CSSProperties["alignItems"];
  $flexGap?: CSSProperties["gap"];
  $marginTop?: CSSProperties["marginTop"];
  $marginBottom?: CSSProperties["marginBottom"];
}>`
  display: flex;
  flex-direction: ${(props) => props.$flexDirection || "row"};
  justify-content: ${(props) => props.$justifyContent || "center"};
  gap: ${(props) => (props.$flexGap ? `${props.$flexGap}px` : "0")};
  align-items: ${(props) => props.$alignItems || "center"};
  width: ${(props) => props.$width || "auto"};
  height: ${(props) => props.$height || "auto"};
  margin-top: ${(props) => props.$marginTop || "0"};
  margin-bottom: ${(props) => props.$marginBottom || "0"};
`;
